<template>
  <div class="hold-transition">
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row mb-2 align-items-center">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right mb-0">
                  <li class="breadcrumb-item">Home</li>
                  <li class="breadcrumb-item active">Argentina</li>
                  <li class="breadcrumb-item active">Operación</li>
                  <li class="breadcrumb-item active">Consulta</li>
                  <li class="breadcrumb-item active">Reportes</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content pb-4">
          <div class="container-fluid">
            <div class="row justify-content-center mb-4 mt-2">
              <div class="col-12 col-lg-10 text-center">
                <h2 class="h3 font-weight-bold text-dark mb-1">
                  Tablero de Reportes
                </h2>
                <p class="text-muted small mb-0">
                  Elija un tipo de reporte para abrir el formulario de
                  exportación
                </p>
              </div>
            </div>
            <div class="row justify-content-center">
              <!-- Reporte Nominacion -->
              <div
                class="col-12 col-sm-6 col-lg-4 col-xl-3 mb-3"
                v-if="$store.getters.can('argentina.reportes.exportNominacion')"
              >
                <div class="card h-100 border-0 shadow-sm">
                  <button
                    type="button"
                    class="btn btn-light btn-block btn-lg shadow-sm text-dark py-3 rounded border-0"
                    data-toggle="modal"
                    data-target="#modal-form-reporte-nominacion"
                  >
                    <i class="fas fa-calendar-alt fa-2x d-block mb-1"></i>
                    <div class="mt-2 mb-0 font-weight-bold text-dark small">
                      Importación de Nominaciones
                    </div>
                  </button>
                </div>
              </div>
              <!-- Reporte Planificacion de Camiones -->
              <div
                class="col-12 col-sm-6 col-lg-4 col-xl-3 mb-3"
                v-if="
                  $store.getters.can(
                    'argentina.reportes.exportPlanificacionCamion'
                  )
                "
              >
                <div class="card h-100 border-0 shadow-sm">
                  <button
                    type="button"
                    class="btn btn-light btn-block btn-lg shadow-sm text-dark py-3 rounded border-0"
                    data-toggle="modal"
                    data-target="#modal-form-reporte-planificacion-camion"
                  >
                    <i class="fas fa-road text-olive fa-2x d-block mb-1"></i>
                    <div class="mt-2 mb-0 font-weight-bold text-dark small">
                      Importación de planificación de camiones
                    </div>
                  </button>
                </div>
              </div>
              <!-- Reporte Carga Mediciones de Liquido -->
              <div
                class="col-12 col-sm-6 col-lg-4 col-xl-3 mb-3"
                v-if="
                  $store.getters.can('argentina.reportes.exportMedicionLiquido')
                "
              >
                <div class="card h-100 border-0 shadow-sm">
                  <button
                    type="button"
                    class="btn btn-light btn-block btn-lg shadow-sm text-dark py-3 rounded border-0"
                    data-toggle="modal"
                    data-target="#modal-form-reporte-carga-mediciones-liquido"
                  >
                    <i
                      class="fas fa-prescription-bottle text-blue fa-2x d-block mb-1"
                    ></i>
                    <div class="mt-2 mb-0 font-weight-bold text-dark small">
                      Reporte Carga Mediciones de Liquido
                    </div>
                  </button>
                </div>
              </div>
              <!-- Reporte Despachos No Operados -->
              <div
                class="col-12 col-sm-6 col-lg-4 col-xl-3 mb-3"
                v-if="
                  $store.getters.can(
                    'argentina.reportes.exportDespachosNoOperados'
                  )
                "
              >
                <div class="card h-100 border-0 shadow-sm">
                  <button
                    type="button"
                    class="btn btn-light btn-block btn-lg shadow-sm text-dark py-3 rounded border-0"
                    data-toggle="modal"
                    data-target="#modal-form-reporte-no-operados-export"
                  >
                    <i class="fa fa-list text-olive fa-2x d-block mb-1"></i>
                    <div class="mt-2 mb-0 font-weight-bold text-dark small">
                      Importación Despachos No Operados
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <ReporteNominacionExport ref="ReporteNominacionExport" />
    <ReporteMedidorLiquidoExport ref="ReporteMedidorLiquidoExport" />
    <ReportePlanificacionCamionExport ref="ReportePlanificacionCamionExport" />
    <ReporteDespachosNoOperadosExport ref="ReporteDespachosNoOperadosExport" />
  </div>
</template>

<script>
import ReporteNominacionExport from "./ReporteNominacionExport";
import ReporteMedidorLiquidoExport from "./ReporteMedidorLiquidoExport";
import ReportePlanificacionCamionExport from "./ReportePlanificacionCamionExport";
import ReporteDespachosNoOperadosExport from "./ReporteDespachosNoOperadosExport";
import axios from "axios";
export default {
  name: "ReporteIndex",
  data() {
    return {
      cargando: false,
      listasForms: {
        listaConsultas: [],
      },
    };
  },
  components: {
    ReporteNominacionExport,
    ReporteMedidorLiquidoExport,
    ReportePlanificacionCamionExport,
    ReporteDespachosNoOperadosExport,
  },

  methods: {},

  beforeMount() {},
};
</script>
